import React, { useContext, useState } from "react";
import fontSize from "../../../images/fontSize.svg"
import PageContext from "../../../store/page-context";
import './accessibility.css'
import { ReactSVG } from "react-svg";
import contrast from "../../../images/icons/contrast.svg"
import dyslexie from "../../../images/icons/dyslexie.svg"

export default function Accessibility() {

    const [toggle, setToggle] = useState(false)
    const [textOptions, setTextOptions] = useState(false)

    const access = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_285_2012)"><path d="M13.8999 2.99898C13.9001 3.3748 13.7888 3.74225 13.5801 4.05483C13.3715 4.36742 13.0748 4.6111 12.7277 4.75506C12.3805 4.89902 11.9984 4.93679 11.6298 4.86359C11.2612 4.79039 10.9225 4.60951 10.6567 4.34383C10.3909 4.07815 10.2098 3.73961 10.1365 3.37102C10.0631 3.00242 10.1006 2.62035 10.2444 2.27311C10.3882 1.92587 10.6317 1.62907 10.9442 1.42025C11.2567 1.21143 11.624 1.09998 11.9999 1.09998C12.5036 1.09998 12.9867 1.30002 13.343 1.65612C13.6993 2.01222 13.8996 2.49524 13.8999 2.99898ZM13.5439 5.99998H10.4559C10.0421 5.99988 9.64022 6.13812 9.31407 6.3927C8.98792 6.64728 8.75624 7.00359 8.65587 7.40498L6.99387 14.057C6.97171 14.1568 6.97281 14.2604 6.99709 14.3598C7.02136 14.4591 7.06816 14.5516 7.13387 14.63C7.21365 14.7305 7.3146 14.8121 7.42954 14.8692C7.54448 14.9262 7.67058 14.9572 7.79887 14.96C7.93931 14.9578 8.07603 14.9145 8.19209 14.8354C8.30816 14.7563 8.39848 14.6449 8.45187 14.515L9.99987 9.09998V13L9.07787 22.219C9.06794 22.3178 9.07884 22.4175 9.10986 22.5118C9.14087 22.6061 9.19132 22.6929 9.25795 22.7665C9.32457 22.8401 9.40589 22.8989 9.49665 22.9391C9.58741 22.9793 9.6856 23.0001 9.78487 23H9.85887C10.0198 22.9999 10.1757 22.9436 10.2995 22.8408C10.4233 22.738 10.5072 22.5952 10.5369 22.437L11.9999 14.583L13.4629 22.437C13.4925 22.5952 13.5765 22.738 13.7003 22.8408C13.8241 22.9436 13.9799 22.9999 14.1409 23H14.2149C14.3141 23.0001 14.4123 22.9793 14.5031 22.9391C14.5938 22.8989 14.6752 22.8401 14.7418 22.7665C14.8084 22.6929 14.8589 22.6061 14.8899 22.5118C14.9209 22.4175 14.9318 22.3178 14.9219 22.219L13.9999 13V9.09998L15.5479 14.515C15.6014 14.6447 15.6918 14.7559 15.8078 14.8348C15.9239 14.9137 16.0605 14.9569 16.2009 14.959C16.3291 14.9563 16.4551 14.9255 16.5701 14.8686C16.685 14.8118 16.786 14.7303 16.8659 14.63C16.9316 14.5516 16.9784 14.4591 17.0027 14.3598C17.0269 14.2604 17.028 14.1568 17.0059 14.057L15.3439 7.40498C15.2435 7.00359 15.0118 6.64728 14.6857 6.3927C14.3595 6.13812 13.9576 5.99988 13.5439 5.99998Z" fill="white" /></g><defs><clipPath id="clip0_285_2012"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>

    const ctx = useContext(PageContext);
    
    const fontHandler = (e) => {

        const scale = Math.round(10*ctx.scale)/10
        let result = Math.round(10*(scale + e))/10;       

        if(scale >= 1 && scale < 2 && e == 0.1){
            ctx.change(result)
        }else if(scale > 1 && scale <= 2 && e == -0.1){
            ctx.change(result)
        }

    }

    return (
        <div className="hq-accessibility">
            {
                toggle ?
                    <div className="hq-accessibility__items">
                        <div className="hq-accessibility__item-container">
                            <div className="hq-accessibility__item" onClick={()=>{setTextOptions(!textOptions)}}><img src={fontSize} /></div>
                            {
                                textOptions ?
                                <div className="hq-accessibility__item-options">
                                    <div className="hq-accessibility__item" onClick={()=>{fontHandler(-0.1)}}>-</div>
                                    <div className="hq-accessibility__item" onClick={()=>{fontHandler(0.1)}}>+</div>
                                </div>
                                : null
                            }
                        </div>
                        <div className="hq-accessibility__item-container">
                            <div className="hq-accessibility__item" onClick={ctx.toggleContrast}><ReactSVG src={contrast} /></div>
                        </div>
                        <div className="hq-accessibility__item-container">
                            <div className="hq-accessibility__item" onClick={ctx.toggleDyslexia}><ReactSVG src={dyslexie} /></div>
                        </div>
                    </div>
                : null
            }
            <div className="hq-accessibility__toggle" onClick={()=>{setToggle(!toggle)}}>{access}</div>
        </div>
    )
}